import React, {useEffect} from "react";
import Select from "@pages/salesPost/form/filter/Select";
import {
    filterBoardTypeOptions, filterSearchItemTypeOptions,
    filterSearchTypeOptions,
    filterTradeTypeOptions
} from "@/presentation/data/options";
import Input from "@pages/salesPost/form/filter/Input";
import {Col, Row} from "react-bootstrap";
import DatePicker from "@pages/salesPost/form/filter/DatePicker";
import {useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import {salesPostFilterState, searchFilterState} from "@pages/salesPost/atoms";


const TableFilter: React.FC = () => {

    const resetFilter = useResetRecoilState(salesPostFilterState);
    const resetSearchFilter = useResetRecoilState(searchFilterState);
    const setFilter = useSetRecoilState(salesPostFilterState);
    const searchFilter = useRecoilValue(searchFilterState);


    const handleSearch = () => {
        setFilter(old => ({
            ...old,
            ...searchFilter
        }))
    }

    const handleReset = () => {
        resetFilter();
        resetSearchFilter();
    }

    useEffect(() => {
        handleReset();
    }, [])

    return (
        <div className={'table_filter'}>
            <ul className={'filter_options'}>
                <li>
                    <div className={'option_name'}>거래종류</div>
                    <Select name={'type'} options={filterTradeTypeOptions}/>
                </li>
                <li>
                    <div className={'option_name'}>게시글 상태</div>
                    <Select name={'state'} options={filterBoardTypeOptions}/>
                </li>
                <li>
                    <div className={'option_name'}>검색어</div>
                    <Row className={'flex-grow-1'}>
                        <Col xs={3} style={{paddingRight: 0}}>
                            <Select name={'itemSearchType'} options={filterSearchItemTypeOptions}/>
                        </Col>
                        <Col xs={9} style={{paddingLeft: 0}}>
                            <Input type={'text'} name={'word'} placeholder={''} maxLength={255}/>
                        </Col>
                    </Row>
                </li>
                <li>
                    <div className={'option_name'}>게시일</div>
                    <Row className={'flex-grow-1'}>
                        <Col xs={5} style={{paddingRight: 0}}>
                            <DatePicker name={'startCreatedDate'}/>
                        </Col>
                        <Col xs={2}>
                            <div className={'time_flow'}>
                                ~
                            </div>
                        </Col>
                        <Col xs={5} style={{paddingLeft: 0}}>
                            <DatePicker name={'endCreatedDate'}/>
                        </Col>
                    </Row>
                </li>
            </ul>
            <div className={'filter_btns'}>
                <button id={'search_btn'} onClick={handleSearch}>검색</button>
                <button id={'init_btn'} onClick={handleReset}>초기화</button>
            </div>
        </div>
    )
}

export default TableFilter;